export default {
  Common: {
    AppName: 'Ôn tập',
    CancelRequest: 'Đã có lỗi xảy ra trong quá trình xử lý',
    Comment: 'Bình luận',
    Year: 'năm',
    Month: 'tháng',
    Date: 'Ngày',
    Hour: 'giờ',
    Minute: 'phút',
    // tt dung
    All: 'Tất cả',
    Thread: 'Đề bài',
    Answer: 'Bài làm',
    TheAnswer: 'Lời giải',
    Avatar: 'Ảnh đại diện',
    ChangeAvatar: 'Thay ảnh',
    FilterBy: 'Lọc theo',
    Have: 'Có',
    Import: 'Nhập khẩu',
    VND: 'vnđ',
    Earnings: 'Thu nhập',
    Description: 'Mô tả',
    Attach: 'Đính kèm',
    Like: 'Thích',
    Reply: 'Trả lời',
    Details: 'Thông tin chi tiết',
    Lesson: 'Bài học',
    Author: 'Tác giả',
    AllSubject: 'Tất cả các môn',
    AllGrade: 'Tất cả các khối',
    AllTopic: 'Tất cả các chủ đề',
    Source: 'Nguồn',
    BuyNow: 'Mua ngay',
    Use: 'Sử dụng',
    Price: 'Giá',
    TimesUsed: 'Lượt dùng',
    Collect: 'Sưu tầm',
    Times: 'lượt',
    Rate: 'Đánh giá',
    ViewAll: 'Xem tất cả',
    Category: 'Danh mục',
    Email: 'Email',
    PhoneNumber: 'Số điện thoại',
    UserName: 'Tên đăng nhập',
    Or: 'hoặc',
    Enter: 'Nhập',
    Name: 'Tên',
    SurnameAndMiddlename: 'Họ và tên đệm',
    Age: 'Tuổi',
    EditInformation: 'Sửa thông tin',
    ViewDetail: 'Xem chi tiết',
    Edit: 'Chỉnh sửa',
    ChangeImage: 'Thay ảnh',
    NumberOfPeople: 'Sĩ số',
    Verification: 'Xác thực',
    Back: 'Trở lại',
    Continue: 'Tiếp tục',
    Teacher: 'Giáo viên',
    Student: 'Học sinh',
    Grade: 'Khối',
    Subject: 'Môn',
    Topic: 'Chủ đề',
    Library: 'Tất cả học liệu',
    Progress: 'Tiến độ',
    AddFile: 'Thêm file',
    False: 'Sai',
    SearchStorage: 'Nhập tên học liệu để tìm kiếm',
    True: 'Đúng',
    CopySentence: 'Sao chép câu',
    Delete: 'Xóa',
    Sentence: 'Câu',
    AddQuestion: 'Thêm câu',
    FeatureInProgress: 'Tính năng đang phát triển',
    Week: 'Tuần',
    YearsAgo: '{years} năm trước',
    MinutesAgo: '{minutes} phút trước',
    HoursAgo: '{hours} giờ trước',
    DaysAgo: '{days} ngày trước',
    JustNow: 'Vừa xong',
    Way: 'Cách',
    SearchEmpty: 'Không tìm thấy dữ liệu',
    DataEmpty: 'Chưa có dữ liệu',
    DataNotExist: 'Dữ liệu không tồn tại',
    UserManual: 'Hướng dẫn sử dụng',
    Theme: 'Giao diện người dùng',
    StatusSyncToGoogleDrive: 'Trạng thái đồng bộ lên Google Drive',
    PlayingMusicTheme: 'Trạng thái nhạc nền của học sinh',
    Period: 'Kỳ đánh giá',
    Point: 'Điểm',
    Coefficient: 'Hệ số',
    Level: 'Mức độ',
    View: 'Xem',
    IsOver: 'Đã kết thúc',
    QuestionNumber: 'Câu (Điểm)',
    ResetExamStatus: 'Nạp lại',
    Demo: 'Làm thử',
    Share: 'Chia sẻ',
    StopShare: 'Ngừng chia sẻ',
    Mine: 'Của tôi',
    AddAttachment: 'Thêm tệp đính kèm',
    AddImgAttachment: 'Thêm hình ảnh',
    Support: 'Hỗ trợ',
    InstallMobileAppMessage:
      'Tải ứng dụng để làm bài tập, bài kiểm tra ngay trên điện thoại',
    InstallMobileAppButton: 'Tải ứng dụng ngay',
    Left: 'trái',
    Right: 'phải',
    HelpTooltip: 'Trợ giúp',
    CardTooltip: 'Giỏ học liệu',
    NotifyTooltip: 'Thông báo',
    SettingTooltip: 'Thiết lập',
    Example: 'Ví dụ',
    SearchEnter: 'Nhập xong nhấn enter để tìm kiếm',
    QuestionWrong: 'Câu hỏi sai',
    SpellingError: 'Lỗi chính tả'
  }
}
